/* VTILTED Luxury: custom cursor + scroll-reveal */
(function () {
  'use strict';

  // --- Size & Fit popup (delegated; runs regardless of reduced-motion) ---
  function closeAllSizefit() {
    document.querySelectorAll('[data-vt-sizefit-overlay]:not([hidden])').forEach(function (o) {
      o.hidden = true;
    });
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-vt-sizefit-open]');
    if (open) {
      var ov = open.closest('[data-vt-sizefit]').querySelector('[data-vt-sizefit-overlay]');
      if (ov) {
        ov.hidden = false;
        document.body.style.overflow = 'hidden';
        open.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    // close on X or on backdrop (click outside the modal)
    if (
      (e.target.closest && e.target.closest('[data-vt-sizefit-close]')) ||
      (e.target.matches && e.target.matches('[data-vt-sizefit-overlay]'))
    ) {
      closeAllSizefit();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllSizefit();
  });

  // --- Make the Shop Pay logo BLACK (it's hardcoded purple inside open shadow
  //     DOM; CSS can't reach it, but JS can — the logo SVG is fill:currentColor) ---
  function blackenShopPay(pt) {
    if (!pt.shadowRoot) return;
    var logo = pt.shadowRoot.querySelector('.text-purple-primary');
    if (logo) logo.style.setProperty('color', '#000', 'important');
    // Shorten copy to "Pay 4 interest-free payments of . [logo]" (Represent)
    var content = pt.shadowRoot.querySelector('#shopify-installments-content');
    if (content && content.getAttribute('data-vt') !== '1') {
      content.childNodes.forEach(function (n) {
        if (n.nodeType === 3) {
          if (/installments?\s+of|payments?\s+of|^\s*Pay\b/i.test(n.textContent)) {
            n.textContent = 'Pay 4 interest-free payments of ';
          } else if (/with/i.test(n.textContent)) {
            n.textContent = ' ';
          }
        } else if (n.nodeType === 1 && n.classList && n.classList.contains('font-bold')) {
          n.textContent = '.'; // amount -> "." like Represent
          n.style.fontWeight = '400';
        }
      });
      content.setAttribute('data-vt', '1');
    }
  }
  function initShopPayBlack() {
    document.querySelectorAll('shopify-payment-terms').forEach(function (pt) {
      blackenShopPay(pt);
      if (pt.shadowRoot && !pt.__vtObs) {
        pt.__vtObs = new MutationObserver(function () { blackenShopPay(pt); });
        pt.__vtObs.observe(pt.shadowRoot, { childList: true, subtree: true });
      }
    });
  }
  var vtSpTries = 0;
  var vtSpTimer = setInterval(function () {
    initShopPayBlack();
    if (++vtSpTries > 25) clearInterval(vtSpTimer);
  }, 300);

  // --- Notify Me → Klaviyo client back-in-stock (public Site ID only) ---
  function vtNotifyClose() {
    var n = document.querySelector('[data-vt-notify]');
    if (n) { n.hidden = true; document.body.style.overflow = ''; }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.js-notify-me')) {
      e.preventDefault();
      var n = document.querySelector('[data-vt-notify]');
      if (n) {
        n.hidden = false;
        document.body.style.overflow = 'hidden';
        var msg = n.querySelector('[data-vt-notify-msg]');
        if (msg) { msg.textContent = ''; msg.className = 'vt-notify__msg'; }
        var inp = n.querySelector('input[type="email"]');
        if (inp) { inp.value = ''; setTimeout(function () { inp.focus(); }, 60); }
      }
      return;
    }
    if (e.target.closest && e.target.closest('[data-vt-notify-close]')) { vtNotifyClose(); return; }
    if (e.target.matches && e.target.matches('[data-vt-notify-overlay]')) { vtNotifyClose(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') vtNotifyClose();
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-vt-notify-form]');
    if (!form) return;
    e.preventDefault();
    var wrap = form.closest('[data-vt-notify]');
    var msg = wrap.querySelector('[data-vt-notify-msg]');
    var btn = form.querySelector('[type="submit"]');
    var email = (form.querySelector('input[type="email"]').value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      msg.textContent = 'Please enter a valid email address.';
      msg.className = 'vt-notify__msg is-error';
      return;
    }
    var companyId = wrap.getAttribute('data-klaviyo');
    var vEl = document.querySelector('product-form [name="id"]') || document.querySelector('[name="id"]');
    var variantId = vEl && vEl.value;
    if (!companyId || !variantId) {
      msg.textContent = 'Something went wrong. Please try again.';
      msg.className = 'vt-notify__msg is-error';
      return;
    }
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Sending…';
    msg.textContent = '';
    msg.className = 'vt-notify__msg';
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      })
    })
      .then(function (r) {
        btn.disabled = false;
        btn.textContent = label;
        if (r.ok) {
          msg.textContent = "You're on the list — we'll email you the moment it's back.";
          msg.className = 'vt-notify__msg is-ok';
          form.reset();
          setTimeout(vtNotifyClose, 2400);
        } else {
          r.text().then(function (t) { console.warn('Klaviyo back-in-stock error', r.status, t); });
          msg.textContent = "Couldn't subscribe right now. Please try again.";
          msg.className = 'vt-notify__msg is-error';
        }
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        console.warn('Klaviyo back-in-stock network error', err);
        msg.textContent = 'Network error. Please try again.';
        msg.className = 'vt-notify__msg is-error';
      });
  });

  // --- "Size Not In Stock?" → per-size Klaviyo back-in-stock ---
  function vtOosClose() {
    var n = document.querySelector('[data-vt-oos]');
    if (n) { n.hidden = true; document.body.style.overflow = ''; }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-vt-oos-open]')) {
      var n = document.querySelector('[data-vt-oos]');
      if (n) {
        n.hidden = false;
        document.body.style.overflow = 'hidden';
        var m = n.querySelector('[data-vt-oos-msg]');
        if (m) { m.textContent = ''; m.className = 'vt-oos__msg'; }
      }
      return;
    }
    if (e.target.closest && e.target.closest('[data-vt-oos-close]')) { vtOosClose(); return; }
    if (e.target.matches && e.target.matches('[data-vt-oos-overlay]')) { vtOosClose(); return; }
    var sizeBtn = e.target.closest && e.target.closest('.vt-oos__size');
    if (sizeBtn) {
      var grp = sizeBtn.closest('.vt-oos__sizes');
      grp.querySelectorAll('.vt-oos__size').forEach(function (x) { x.classList.remove('is-selected'); });
      sizeBtn.classList.add('is-selected');
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') vtOosClose(); });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-vt-oos-form]');
    if (!form) return;
    e.preventDefault();
    var wrap = form.closest('[data-vt-oos]');
    var msg = wrap.querySelector('[data-vt-oos-msg]');
    var btn = form.querySelector('[type="submit"]');
    var sel = wrap.querySelector('.vt-oos__size.is-selected');
    var email = (form.querySelector('input[type="email"]').value || '').trim();
    if (!sel) { msg.textContent = 'Please select a size.'; msg.className = 'vt-oos__msg is-error'; return; }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { msg.textContent = 'Please enter a valid email address.'; msg.className = 'vt-oos__msg is-error'; return; }
    var companyId = wrap.getAttribute('data-klaviyo');
    var variantId = sel.getAttribute('data-variant-id');
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Sending…';
    msg.textContent = ''; msg.className = 'vt-oos__msg';
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
        }
      })
    })
      .then(function (r) {
        btn.disabled = false; btn.textContent = label;
        if (r.ok) {
          msg.textContent = "You're on the list — we'll email you when your size is back.";
          msg.className = 'vt-oos__msg is-ok';
          form.reset();
          wrap.querySelectorAll('.vt-oos__size').forEach(function (x) { x.classList.remove('is-selected'); });
          setTimeout(vtOosClose, 2600);
        } else {
          r.text().then(function (t) { console.warn('Klaviyo BIS (size) error', r.status, t); });
          msg.textContent = "Couldn't subscribe right now. Please try again.";
          msg.className = 'vt-oos__msg is-error';
        }
      })
      .catch(function (err) {
        btn.disabled = false; btn.textContent = label;
        console.warn('Klaviyo BIS (size) network error', err);
        msg.textContent = 'Network error. Please try again.';
        msg.className = 'vt-oos__msg is-error';
      });
  });

  // --- Search: clean predictive drawer (drops from the top) ---
  var vtSearch = document.querySelector('[data-vt-search]');
  if (vtSearch) {
    var sInput   = vtSearch.querySelector('[data-vt-search-input]');
    var sForm    = vtSearch.querySelector('[data-vt-search-form]');
    var sResults = vtSearch.querySelector('[data-vt-results]');
    var sSuggest = vtSearch.querySelector('[data-vt-suggest]');
    var sChips   = vtSearch.querySelector('[data-vt-suggestions]');
    var sEmpty   = vtSearch.querySelector('[data-vt-empty]');
    var sTabs    = vtSearch.querySelectorAll('[data-vt-tab]');
    var sPanels  = {
      products:    vtSearch.querySelector('[data-vt-panel="products"]'),
      collections: vtSearch.querySelector('[data-vt-panel="collections"]'),
      pages:       vtSearch.querySelector('[data-vt-panel="pages"]')
    };

    var esc = function (s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };

    var showClean = function () { if (sResults) sResults.hidden = true; };

    var openSearch = function (e) {
      if (e) e.preventDefault();
      // start the drawer just below the header so the header stays visible
      var header = document.querySelector('#header');
      var top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      vtSearch.style.top = top + 'px';
      vtSearch.hidden = false;
      vtSearch.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        vtSearch.classList.add('is-open');
        if (sInput) sInput.focus();
      });
    };
    var closeSearch = function () {
      vtSearch.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { vtSearch.hidden = true; vtSearch.setAttribute('aria-hidden', 'true'); }, 340);
    };

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.vt-mobile-search, .thb-quick-search')) { openSearch(e); return; }
      if (e.target.closest && e.target.closest('[data-vt-search-close]')) { closeSearch(); return; }
      if (e.target.matches && e.target.matches('[data-vt-search-overlay]')) { closeSearch(); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && vtSearch.classList.contains('is-open')) closeSearch();
    });

    // Tabs
    function selectTab(name) {
      Array.prototype.forEach.call(sTabs, function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-vt-tab') === name);
      });
      Object.keys(sPanels).forEach(function (k) {
        if (sPanels[k]) sPanels[k].classList.toggle('is-active', k === name);
      });
    }
    Array.prototype.forEach.call(sTabs, function (t) {
      t.addEventListener('click', function () { selectTab(t.getAttribute('data-vt-tab')); });
    });

    // View all results -> full search page
    var viewAll = vtSearch.querySelector('[data-vt-viewall]');
    if (viewAll && sForm) viewAll.addEventListener('click', function () {
      if ((sInput.value || '').trim()) sForm.submit();
    });

    function productRow(p) {
      var img = (p.featured_image && p.featured_image.url)
        ? '<span class="vt-row__img"><img src="' + p.featured_image.url + '&width=160" alt="" loading="lazy"></span>'
        : '<span class="vt-row__img"></span>';
      var price = (p.price != null && p.price !== '')
        ? (String(p.price).indexOf('$') === -1 ? '$' + p.price : p.price) : '';
      return '<a class="vt-row" href="' + esc(p.url) + '">' + img +
        '<span class="vt-row__meta"><span class="vt-row__title">' + esc(p.title) + '</span>' +
        (price ? '<span class="vt-row__price">' + esc(price) + '</span>' : '') + '</span></a>';
    }
    function linkRow(item) {
      return '<a class="vt-row vt-row--text" href="' + esc(item.url) + '">' +
        '<span class="vt-row__title">' + esc(item.title) + '</span></a>';
    }

    function render(data) {
      var r = (data && data.resources && data.resources.results) || {};
      var products    = r.products    || [];
      var collections = r.collections || [];
      var pages       = r.pages       || [];
      var queries     = r.queries     || [];

      if (queries.length) {
        sChips.innerHTML = queries.slice(0, 8).map(function (qi) {
          return '<a class="vt-search__chip" href="/search?q=' + encodeURIComponent(qi.text) + '">' +
            (qi.styled_text || esc(qi.text)) + '</a>';
        }).join('');
        sSuggest.hidden = false;
      } else {
        sChips.innerHTML = '';
        sSuggest.hidden = true;
      }

      sPanels.products.innerHTML    = products.length    ? products.map(productRow).join('') : '<p class="vt-search__none">No matching products.</p>';
      sPanels.collections.innerHTML = collections.length ? collections.map(linkRow).join('') : '<p class="vt-search__none">No matching collections.</p>';
      sPanels.pages.innerHTML       = pages.length       ? pages.map(linkRow).join('')       : '<p class="vt-search__none">No matching pages.</p>';

      var any = products.length || collections.length || pages.length || queries.length;
      sEmpty.hidden = !!any;

      selectTab(products.length ? 'products' : (collections.length ? 'collections' : (pages.length ? 'pages' : 'products')));
      sResults.hidden = false;
    }

    var vtT, vtSeq = 0;
    if (sInput) sInput.addEventListener('input', function () {
      var q = sInput.value.trim();
      clearTimeout(vtT);
      if (!q) { showClean(); return; }
      var seq = ++vtSeq;
      vtT = setTimeout(function () {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,query' +
          '&resources[limit]=8' +
          '&resources[options][unavailable_products]=last';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (data) { if (seq === vtSeq) render(data); })
          .catch(function () {});
      }, 220);
    });
  }

  // --- Sign-in overlay (full-screen plasma) opened by the header account icon ---
  var vtSignin = document.querySelector('[data-vt-signin]');
  if (vtSignin) {
    var siEmail = vtSignin.querySelector('[data-vt-signin-email]');
    var siForm = vtSignin.querySelector('[data-vt-signin-form]');
    var openSignin = function (e) {
      if (e) e.preventDefault();
      vtSignin.hidden = false;
      vtSignin.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        vtSignin.classList.add('is-open');
        if (siEmail) siEmail.focus();
      });
    };
    var closeSignin = function () {
      vtSignin.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { vtSignin.hidden = true; vtSignin.setAttribute('aria-hidden', 'true'); }, 320);
    };
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-vt-signin-open]')) { openSignin(e); return; }
      if (e.target.closest && e.target.closest('[data-vt-signin-close]')) { closeSignin(); return; }
      if (e.target.matches && e.target.matches('[data-vt-signin]')) { closeSignin(); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && vtSignin.classList.contains('is-open')) closeSignin();
    });
    // Continue → hand off to Shopify's hosted sign-in (new accounts = email + code),
    // carrying the typed email so the hosted page can prefill it.
    if (siForm) siForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var dest = siForm.getAttribute('action');
      var val = siEmail && siEmail.value ? siEmail.value.trim() : '';
      if (val) { dest += (dest.indexOf('?') > -1 ? '&' : '?') + 'email=' + encodeURIComponent(val); }
      window.location.href = dest;
    });
  }

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  function init() {
    // --- Logo: swap bold wordmark -> animated V on scroll (Represent-style) ---
    var onLogoScroll = function () {
      if (window.scrollY > 60) {
        document.body.classList.add('vt-scrolled');
      } else {
        document.body.classList.remove('vt-scrolled');
      }
    };
    onLogoScroll();
    window.addEventListener('scroll', onLogoScroll, { passive: true });

    // --- PDP: fade the header away past ~68% of the product image, fade back
    //     in on scroll-up (position-based, symmetric — Represent style) ---
    var pdp = document.querySelector('.thb-product-detail');
    if (pdp) {
      var hdrTicking = false;
      var updateHeaderFade = function () {
        hdrTicking = false;
        var img =
          pdp.querySelector('.product-single__media-image') ||
          pdp.querySelector('.product-image-container');
        if (!img) return;
        var rect = img.getBoundingClientRect();
        var absTop = rect.top + window.scrollY;
        var threshold = absTop + rect.height * 0.68;
        if (window.scrollY > threshold) {
          document.body.classList.add('vt-header-faded');
        } else {
          document.body.classList.remove('vt-header-faded');
        }
      };
      window.addEventListener(
        'scroll',
        function () {
          if (!hdrTicking) { hdrTicking = true; requestAnimationFrame(updateHeaderFade); }
        },
        { passive: true }
      );
      window.addEventListener('resize', updateHeaderFade);
      updateHeaderFade();
    }

    // --- Homepage: fade the transparent header out ~60% through the hero ---
    var heroEl = document.querySelector('.vt-hero');
    if (heroEl && document.body.classList.contains('template-index')) {
      var hTick = false;
      var heroFade = function () {
        hTick = false;
        var h = heroEl.offsetHeight || window.innerHeight;
        if (window.scrollY > h * 0.6) document.body.classList.add('vt-home-faded');
        else document.body.classList.remove('vt-home-faded');
      };
      window.addEventListener('scroll', function () { if (!hTick) { hTick = true; requestAnimationFrame(heroFade); } }, { passive: true });
      window.addEventListener('resize', heroFade);
      heroFade();
    }

    // --- Sticky Add to Cart: visible while the real button is out of view,
    //     hides the moment you scroll down to it ---
    var realAtc = document.getElementById('AddToCart');
    var stickyWrap = document.querySelector('[data-vt-sticky-atc]');
    var stickyBtn = document.querySelector('[data-vt-sticky-atc-btn]');
    if (realAtc && stickyWrap && stickyBtn && 'IntersectionObserver' in window) {
      var syncStickyLabel = function () {
        var t = realAtc.querySelector('.single-add-to-cart-button--text');
        var txt = ((t ? t.textContent : realAtc.textContent) || '').trim();
        if (txt) stickyBtn.textContent = txt;
      };
      syncStickyLabel();
      new MutationObserver(syncStickyLabel).observe(realAtc, { childList: true, subtree: true, characterData: true });
      stickyBtn.addEventListener('click', function () { realAtc.click(); });
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) stickyWrap.classList.remove('is-visible');
          else stickyWrap.classList.add('is-visible');
        });
      }, { threshold: 0 }).observe(realAtc);
    }

    // --- Scroll-reveal for sections ---
    if ('IntersectionObserver' in window) {
      var sections = document.querySelectorAll(
        'main .shopify-section, #MainContent .shopify-section'
      );

      var obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('is-in');
              obs.unobserve(e.target);
            }
          });
        },
        { threshold: 0.06, rootMargin: '0px 0px -8% 0px' }
      );

      sections.forEach(function (s, i) {
        if (i === 0) {
          s.classList.add('is-in');
          return;
        }
        var rect = s.getBoundingClientRect();
        if (rect.top < window.innerHeight - 60) {
          s.classList.add('is-in');
        } else {
          s.classList.add('vt-reveal');
          obs.observe(s);
        }
      });
    }

    // --- Custom cursor (desktop only, non-touch) ---
    var supportsHover =
      window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!supportsHover) return;

    var cursor = document.createElement('div');
    cursor.className = 'vt-cursor';
    document.body.appendChild(cursor);
    document.body.classList.add('vt-cursor-active');

    var visible = false;
    document.addEventListener('mousemove', function (e) {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
      if (!visible) {
        cursor.classList.add('is-active');
        visible = true;
      }
    });

    document.addEventListener('mouseleave', function () {
      cursor.classList.remove('is-active');
      visible = false;
    });

    document.addEventListener('mousedown', function () {
      cursor.classList.add('is-clicking');
    });
    document.addEventListener('mouseup', function () {
      cursor.classList.remove('is-clicking');
    });

    // Enlarge on hoverable elements
    var hoverSelector =
      'a, button, .btn, .button, .product-card, .card-wrapper, [role="button"]';

    document.addEventListener(
      'mouseover',
      function (e) {
        if (e.target.closest && e.target.closest(hoverSelector)) {
          cursor.classList.add('is-hovering');
        }
      },
      true
    );

    document.addEventListener(
      'mouseout',
      function (e) {
        if (e.target.closest && e.target.closest(hoverSelector)) {
          cursor.classList.remove('is-hovering');
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
